var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    id: "newlayout__link-arrow",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.293 8.293l-11 11a1 1 0 001.414 1.414l11-11L18 12l3-9-9 3 2.293 2.293z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHead);
export default __webpack_public_path__ + "static/media/arrow-head.bb2c1498.svg";
export { ForwardRef as ReactComponent };